module.exports = __webpack_public_path__ + "10b960d228ff6f3359c179f1262e2974.svg";